// Campus photo for /colleges/georgia-institute-of-technology: CC0 1.0, by Mistercontributer, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ATech_Tower_Building_-_2.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/georgia-institute-of-technology/; credited under the photo.
const photo = {
    "slug": "georgia-institute-of-technology",
    "alt": "Tech Tower, the Lettie Pate Whitehead Evans Administration Building, at Georgia Tech in Atlanta",
    "src": "/colleges/georgia-institute-of-technology/campus-1600.webp",
    "srcSmall": "/colleges/georgia-institute-of-technology/campus-800.webp",
    "srcMid": "/colleges/georgia-institute-of-technology/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/georgia-institute-of-technology/og.jpg",
    "title": "Tech Tower Building - 2",
    "author": "Mistercontributer",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ATech_Tower_Building_-_2.jpg",
    "read": "2026-09-30"
};

export default photo;
